import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import './newsPromotions.css';

const promotionsData = [
  { id: 1, title: "10% Off Services", date: "Valid until 2026-10-31", content: "Get 15% off on all services until the end of the year.", image: "/images/11.jpeg" },
  { id: 2, title: "Free Consultation", date: "Available now", content: "Enjoy a free initial consultation for new clients!", image: "/images/12.jpeg" },
  { id: 3, title: "Referral Bonus", date: "Ongoing", content: "Refer a friend and earn a 15% discount on your next service.", image: "/images/13.jpeg" }
];

const newsData = [
  {
    id: 1,
    title: 'Manduwasa Water Supply Installation Completed',
    date: '2026-03-22',
    content: "Divine-Tech Engineering has completed the Manduwasa water supply installation, including pipeline layout, pump installation and final commissioning — delivering reliable water access to the community.",
    image: '/images/9.jpeg'
  },
  {
    id: 2,
    title: 'Solar-Powered Baseflow System Launched',
    date: '2026-03-10',
    content: "A new solar-powered water supply system under the Baseflow initiative has been successfully commissioned, offering a sustainable supply solution for remote communities.",
    image: '/images/10.jpeg'
  },
  {
    id: 3,
    title: 'Rehabilitation Project Restores Solar System Performance',
    date: '2026-02-28',
    content: "Rehabilitation works restored capacity and reliability to a solar-powered water system, reducing downtime and improving daily output.",
    image: '/images/11.jpeg'
  },
  {
    id: 4,
    title: '100 Water Meters Installed in Dowa District',
    date: '2026-02-12',
    content: "As part of the Afridev borehole programme, 100 water meters were installed and calibrated, enabling better water usage tracking and billing where needed.",
    image: '/images/12.jpeg'
  },
  {
    id: 5,
    title: 'New Fabrication Solutions Expand Local Capacity',
    date: '2026-01-30',
    content: "DTE expanded its fabrication services with new meter boxes, tanks and structural components designed locally for durability and cost-effectiveness.",
    image: '/images/14.jpeg'
  },
  {
    id: 6,
    title: 'Pump Installation Drive Continues Across Rural Sites',
    date: '2026-01-15',
    content: "Ongoing submersible pump installations support multiple rural communities, backed by preventative maintenance plans and field training.",
    image: '/images/13.jpeg'
  }
];
 

function useCardsPerPage() {
  const [cardsPerPage, setCardsPerPage] = useState(3);

  useEffect(() => {
    const update = () => {
      const width = window.innerWidth;
      if (width < 576) setCardsPerPage(1);
      else if (width < 992) setCardsPerPage(2);
      else setCardsPerPage(3);
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return cardsPerPage;
}

function paginate(items, pageSize) {
  const pages = [];
  for (let i = 0; i < items.length; i += pageSize) {
    pages.push(items.slice(i, i + pageSize));
  }
  return pages;
}

function CardsSlider({ heading, subtitle, items }) {
  const cardsPerPage = useCardsPerPage();
  const pages = useMemo(() => paginate(items, cardsPerPage), [items, cardsPerPage]);
  const [activePage, setActivePage] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(null);

  useEffect(() => {
    setActivePage(0);
  }, [cardsPerPage, items]);

  useEffect(() => {
    if (isPaused) return;
    if (pages.length <= 1) return;

    const id = window.setInterval(() => {
      setActivePage((prev) => (prev + 1) % pages.length);
    }, 9000);

    return () => window.clearInterval(id);
  }, [isPaused, pages.length]);

  const goPrev = () => {
    setActivePage((prev) => (prev - 1 + pages.length) % pages.length);
  };

  const goNext = () => {
    setActivePage((prev) => (prev + 1) % pages.length);
  };

  const handleTouchStart = (event) => {
    touchStartX.current = event.touches?.[0]?.clientX ?? null;
  };

  const handleTouchEnd = (event) => {
    const startX = touchStartX.current;
    const endX = event.changedTouches?.[0]?.clientX ?? null;
    touchStartX.current = null;

    if (startX === null || endX === null) return;
    const delta = endX - startX;
    if (Math.abs(delta) < 50) return;

    if (delta < 0) goNext();
    else goPrev();
  };

  const visible = pages[activePage] ?? [];

  return (
    <section
      className="np-block"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="np-header">
        <h2 className="np-title">{heading}</h2>
        <p className="np-subtitle">{subtitle}</p>
      </div>

      <div
        className="np-grid"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {visible.map((item) => (
          <article className="np-card" key={item.id}>
            <div className="np-card-top">
              <div className="np-avatar">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="np-meta">
                <div className="np-name">{item.title}</div>
                <div className="np-role">{item.date}</div>
                {/* <div className="np-stars" aria-label="5 star rating">
                  {'★★★★★'}
                </div> */}
              </div>

              <div className="np-quote" aria-hidden="true">“</div>
            </div>

            <p className="np-text">{item.content}</p>

            <div className="np-divider" />

            <div className="np-footer">
              <span className="np-chip">DTE</span>
              {/* <span className="np-verified">
                <span className="np-verified-dot" aria-hidden="true" /> Verified
              </span> */}
            </div>
          </article>
        ))}
      </div>

      {pages.length > 1 && (
        <div className="np-controls" aria-label={`${heading} controls`}>
          <button
            type="button"
            className="np-arrow"
            onClick={goPrev}
            aria-label={`Previous ${heading} items`}
          >
            ‹
          </button>

          <div className="np-dots" role="tablist" aria-label={`${heading} pagination`}>
            {pages.map((_, idx) => (
              <button
                key={idx}
                type="button"
                className={idx === activePage ? 'np-dot np-dot-active' : 'np-dot'}
                onClick={() => setActivePage(idx)}
                aria-label={`Go to page ${idx + 1}`}
                aria-current={idx === activePage ? 'true' : 'false'}
              />
            ))}
          </div>

          <button
            type="button"
            className="np-arrow"
            onClick={goNext}
            aria-label={`Next ${heading} items`}
          >
            ›
          </button>
        </div>
      )}
    </section>
  );
}

function NewsPromotions() {
  return (
    <Container className="my-5 news-promotions-section">
      <CardsSlider
        heading="Promotions"
        subtitle="Latest offers and updates from DTE."
        items={promotionsData}
      />
      <CardsSlider
        heading="News"
        subtitle="Project milestones, partnerships, and announcements."
        items={newsData}
      />
    </Container>
  );
}

export default NewsPromotions;
